import './samsung.scss'
import samsung from '../../../static/images/comms1.jpg'

function Samsung(){
    return(
        <div className='samsung'>
          <div className='samsungContainer'>
                <div className='background'>
                <img src={samsung} alt='cloud' width='100%' />
                </div>
                

                <div className='heading-title'>
                    <div className='title'>
                        <h1>Samsung PABX Systems</h1>
                        <p>As the Samsung PABX product range is riding off into the sunset, STC will continue
                             to offer limited support to customers whilst restructuring our product offerings to fit 
                             the unique needs of our customers.</p>
                    </div> 
                </div>

                <div className='content-element'>
                    <div className='header'>
                        <div className="services-header">
                            <h3>Farewell</h3>
                                <p>Samsung, the world leader in cutting edge mobile and telephony designs is also a trail blazer 
                                    in PABX technology, announced that the Samsung PABX range will be discontinued. Standard 
                                    Telephones and Cables as an authorized dealer, will continue to offer limited support for 
                                    the Samsung PABX Systems whilst taking proactive steps with our customers as Samsung will 
                                    eventually stop manufacturing replacement parts. Below are some of the Samsung PABX product 
                                    ranges that STC continues to support.</p>
                        </div>
                    </div>
                </div>
                <div className='head'>
                    <h1>Products Supported</h1>
                </div>
                <div className='content-element'>
                    <div className='header'>
                        <div className="services-header">
                                <p>Choosing a phone system for your business requires careful consideration. You want it to serve your business 
                                    well, now and into the future. Your telephone system must be able to scale with your business’ growth, 
                                    without breaking the bank in the process. Our unified communication system is an open-platform, VoIP 
                                    communication system that works with popular IP Phones and SIP trunks whether on premise or in the cloud. 
                                    It eliminates the cost and management headaches of outdated, traditional phone systems or the limitations 
                                    of shared cloud PBXs.</p>
                                    <p>You decide where to run your communication system. You can run the system on an 
                                        existing server or in the cloud, either way you are in control.</p>
                        </div>
                    </div>
                </div>

                <div className='head'>
                    <h1>Product Features</h1>
                </div>

                <div className='services'>
                    <div className='service'>
                        <h2>Samsung Digital Communication System (DCS) Telephones</h2>
                        <p>The Samsung Digital Communication System (DCS) Telephones offer a user friendly design with easy access to 
                            system features. Samsung Handsets can be connected to telephone systems ( IP or PBX ) to allow a full 
                            connectivity and collaboration among offices and businesses.</p>
                        <p>This digital telephone is intended to be connected as a digital extension of a Samsung PABX telephone system 
                            (OfficeServ7030,7070,7100,7200 and 7400). The connection allows voice communication between the central
                             processor unit and the telephone. It is not intended to be connected to any other telephone system or 
                             the public tele-phone network. Some of the features include three way conference call and voicemail 
                             features.</p>                
                    </div>

                    <div className='service'>
                            <h2>Samsung OfficeServ 7030 IP PABX Phone System</h2>
                            <p>OfficeServ 7030 is the best communication product for offices with 4 to 20 lines and provides 
                                advanced functions including voice and applications. Users can enjoy various phone functions
                                 and applications using the various devices such as digital phones, IP phones, WLAN phones,
                                  PCs and servers.</p>
                                 <ul>
                                    <li>Offers small businesses an unrivalled level of features and functional flexibility</li>
                                    <li>Offer 1 to 20 extensions</li>
                                    <li>Can be configured with a full range of analog, digital and IP trunks and extensions</li>
                                    <li>Affordable & flexible configuration options, Analogue or Digital Capabilities</li>
                                    <li>Caller ID, name and number available</li>
                                    <li>VoIP Technology.</li>
                                 </ul>
                    </div>

                    <div className='service'>
                            <h2>Samsung OfficeServ 7070 IP PABX Phone System</h2>
                            <p>Samsung OfficeServ 7070 is an IP-PBX optimized for small and medium sized businesses having less than 50 employees.
                            It supports not only VoIP communications, but works perfectly with existing communication infrastructures</p>
                            <ul>
                                    <li>Supports all the call functions of the existing PBX Full compatibility with the OfficeServ 
                                        7000 series using identical S/W and terminals</li>
                                    <li>Scalability of multiple service boards into the universal slot</li>
                                    <li>Various line groups can be configured through expansion in 4-line unit</li>
                                    <li>Supports 8 VoIP channels without additional equipment</li>
                                    <li>An integrated VoIP network can provide seamless collaboration with a remote office</li>
                                    <li>Supports Voice Mail, Auto Attendant, and CID function without additional equipment Equipped 
                                        with Internal MOH, External MOH, Paging, and Contact</li>
                                 </ul>
                    </div>
                    <div className='service'>
                        <h2>Samsung OfficeServ 7400 IP PABX Phone System</h2>
                            <p>The Samsung OfficeServ 7400 is Samsung’s premier telephone system. The OfficeServ 7400 features a robust feature
                                 package including converged voice and data, VoIP, unified messaging and wireless keysets.</p>
                            <ul>
                                    <li>Simultaneously supports traditional voice communication, VoIP, IP-based data communication and wireless 
                                        solutions through wireless LANs</li>
                                    <li>Provides gigabit Ethernet backbone alongside Layer 2/3 LAN switching capabitlies to carry your evolving traffic needs</li>
                                    <li>Integrates your firewall, VPN, and intrusion Detection System (IDS)</li>
                                    <li>Feature Rich functionality with call forwarding, caller ID, call overflow options, speed calling and wireless service options</li>
                                    <li>Supports up to 480 phones in a single site or thousands of users in a multisite network</li>
                                    <li>Handles any of Samsung’s wired, wireless, digital, IP and analogue range of handsets</li>
                                    <li>Perfect for medium to large businesses</li>
                                 </ul>
                    </div>              
                </div>  
            </div>                 
        </div>
    )
}

export default Samsung;